<template>
  <label :class="`custom-input ${loginWithValue ? 'loginWithValueInput' : ''}`" :name="name">
    <input v-model="inputVal" :type="type" :style="inputStyle" :required="req" :maxlength="maxLength" :autocomplete="autoComplete" :pattern="pattern" :value="inputVal" />
    <span class="placeholder2" :style="labelStyle">{{ title }}</span>
  </label>
</template>

<script>
export default {
  name: 'main-input',
  props: {
    loginWithValue:{
      type:Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    inputStyle: {
      type: String,
      default: 'width: 100%;',
    },
    labelStyle: {
      type: String,
      default: 'right:5%;',
    },
    isError: {
      type: Boolean,
      default: false,
    },
    req: {
      type: Boolean,
      default: true,
    },
    autoComplete: {
      type: String,
      default: 'off',
    },
    pattern: {
      type: String,
    },
    maxLength: {
      type: String,
    },
    value: null,
  },

  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../design/globalCss.scss';

input {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 4px;
  border: 1px solid #d7d7d7;
  outline: none;
  height: 39px;
  padding: 0 15px;
}
.custom-input {
  width: 100%;
  position: relative;
  font-size: 16px;
  font-weight: 400;
  font-family: IRANSans;
}
.placeholder2 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: $gray-color;
  transition: top 0.2s ease;
  padding: 0 5px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: right;
  font-family: IRANSans !important;
}
.custom-input input:valid + .placeholder2,
.custom-input input + .placeholder2 {
  // top: 0;
  background: transparent;
  font-size: 12px;
}
.custom-input input:focus + .placeholder2 {
  background: white;
  top: 0;
}
.loginWithValueInput input:valid + .placeholder2
{
  background: white;
  top: 0 !important;
}
input {
  border: 1px solid $blue-color;
}

.error {
  border: 1px solid $red-color;
  box-sizing: border-box;
  border-radius: 8px;
}
.error + .placeholder2 {
  box-sizing: border-box;
  border-radius: 8px;
  color: $red-color;
}
input + .placeholder2 {
  color: $blue-color !important;
}
input:valid + .placeholder2 {
  top: 50%;
  transform: translateY(-50%);
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px white inset !important;
}
</style>
